/* ============================================================================
   CY REGION SWITCHER
   Adds a country dropdown to the end of the header icon row, after the cart.

   Why JavaScript: the icon row is rendered inside sections/header-inline-blocks
   .liquid, an original theme file this project never edits, and that section's
   schema accepts only mega blocks - so there is no settings-level slot for it.
   A separate cy-* asset keeps the theme file untouched.

   Why drawn flags instead of emoji: Windows has no glyphs for regional-indicator
   pairs, so an emoji flag renders as bare letters ("US") for most of this
   store's audience. These are tiny inline SVGs - no glyph coverage needed, no
   extra request. The Middle East storefront takes the UAE flag.

   The destinations are separate storefronts, not Shopify markets, so these are
   plain external links rather than a /localization form.

   WHERE THE LIST COMES FROM. Theme settings -> Cybeart Custom -> "Region
   switcher - destinations", six slots, bridged to here as
   window.CY_SETTINGS.regions by snippets/cy-settings.liquid. FALLBACK below is
   the same four rows hard-coded; it is used only when that bridge is missing or
   yields nothing, so the switcher can never silently disappear because a
   snippet failed to render. `host` is not a setting - it is derived from each
   url, so a domain cannot be typed twice and disagree with itself.
   ========================================================================== */
(function () {
  'use strict';
  function escHtml(v) { return String(v == null ? '' : v).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var FLAG_US =
    '<svg class="cy-region__flag" viewBox="0 0 24 16" aria-hidden="true" focusable="false">' +
    '<rect width="24" height="16" fill="#FFF"/>' +
    '<g fill="#B22234"><rect width="24" height="2.3"/><rect y="4.6" width="24" height="2.3"/>' +
    '<rect y="9.2" width="24" height="2.3"/><rect y="13.8" width="24" height="2.2"/></g>' +
    '<rect width="10" height="9.2" fill="#3C3B6E"/></svg>';

  var FLAG_CA =
    '<svg class="cy-region__flag" viewBox="0 0 24 16" aria-hidden="true" focusable="false">' +
    '<rect width="24" height="16" fill="#FFF"/>' +
    '<rect width="6" height="16" fill="#D52B1E"/><rect x="18" width="6" height="16" fill="#D52B1E"/>' +
    '<path d="M12 3.2l1.25 2.7 2.7-.75-1.05 2.6 2.3 1.45-2.7.6.2 2.7L12 11.2l-2.7 1.3.2-2.7-2.7-.6 2.3-1.45-1.05-2.6 2.7.75z" fill="#D52B1E"/></svg>';

  var FLAG_IN =
    '<svg class="cy-region__flag" viewBox="0 0 24 16" aria-hidden="true" focusable="false">' +
    '<rect width="24" height="5.34" fill="#FF9933"/><rect y="5.34" width="24" height="5.33" fill="#FFF"/>' +
    '<rect y="10.67" width="24" height="5.33" fill="#138808"/>' +
    '<circle cx="12" cy="8" r="1.9" fill="none" stroke="#000080" stroke-width="1"/></svg>';

  /* UAE flag stands in for the Middle East storefront */
  var FLAG_AE =
    '<svg class="cy-region__flag" viewBox="0 0 24 16" aria-hidden="true" focusable="false">' +
    '<rect x="6" width="18" height="5.34" fill="#00732F"/>' +
    '<rect x="6" y="5.34" width="18" height="5.33" fill="#FFF"/>' +
    '<rect x="6" y="10.67" width="18" height="5.33" fill="#000"/>' +
    '<rect width="6" height="16" fill="#FF0000"/></svg>';

  var FLAG_BY_KEY = { us: FLAG_US, ca: FLAG_CA, ae: FLAG_AE, 'in': FLAG_IN, none: '' };

  var FALLBACK = [
    { name: 'United States', code: 'US',  cur: 'USD', flag: FLAG_US, host: 'cybeart.com',    url: 'https://cybeart.com/' },
    { name: 'Canada',        code: 'CA',  cur: 'CAD', flag: FLAG_CA, host: 'cybeart.ca',     url: 'https://cybeart.ca/' },
    { name: 'Middle East',   code: 'MEA', cur: 'AED', flag: FLAG_AE, host: 'cybeartmea.com', url: 'https://cybeartmea.com/' },
    { name: 'India',         code: 'IN',  cur: 'INR', flag: FLAG_IN, host: 'cybeart.in',     url: 'https://cybeart.in/' }
  ];

  /* the domain a row points at, used to decide which region we are currently on.
     Derived rather than configured. URL() throws on a malformed address, so a
     typo in the panel costs that one row its flag match, not the whole script. */
  function hostOf(url) {
    try { return new URL(url, window.location.href).hostname.replace(/^www./, ''); }
    catch (e) { return ''; }
  }

  function fromSettings() {
    var cfg = window.CY_SETTINGS && window.CY_SETTINGS.regions;
    if (!cfg || !cfg.length) return null;
    var out = [];
    for (var i = 0; i < cfg.length; i++) {
      var r = cfg[i];
      if (!r || !r.name || !r.url) continue;
      var flag = FLAG_BY_KEY[r.flag];
      if (r.flag === 'image') {
        /* an uploaded flag: same class as the SVGs, so it inherits their size */
        flag = r.img ? '<img class="cy-region__flag" src="' + r.img + '" alt="" aria-hidden="true" loading="lazy">' : '';
      }
      out.push({
        name: r.name,
        code: r.code || '',
        cur: r.cur || '',
        flag: flag || '',
        host: hostOf(r.url),
        url:  r.url
      });
    }
    return out.length ? out : null;
  }

  var REGIONS = fromSettings() || FALLBACK;

  var CHECK = '<svg class="cy-region__check" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
    '<path d="M3.5 8.5l3 3 6-7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CARET = '<svg class="cy-region__caret" viewBox="0 0 10 7" aria-hidden="true" focusable="false">' +
    '<path d="M10 1.24L5 6.24 0 1.24.89.35 5 4.47 9.11.35 10 1.24z" fill="currentColor"/></svg>';

  function currentRegion() {
    var host = window.location.hostname.replace(/^www\./, '');
    for (var i = 0; i < REGIONS.length; i++) {
      if (host === REGIONS[i].host || host.indexOf(REGIONS[i].host) > -1) return REGIONS[i];
    }
    return REGIONS[0];   // the dev store is none of them; US is the default storefront
  }

  /* ---- SHIP TO, redesigned (owner 2026-10-11: "Ship to - Country selector - disabled for selected country - also refine
     functionality in mobile - re-think this part again and design with creativity and premium"; mobile = 2x2 flag tiles, currencies
     shown). The store the visitor is on is a card marked "You're here" that cannot be clicked (it used to reload the same store);
     the other stores are links with their currency; a note says each country is its own store. Wording + currencies come from
     Theme settings > Cybeart — Region switcher (window.CY_SETTINGS.regionText / regions[].cur). ---- */
  var TXT = (window.CY_SETTINGS && window.CY_SETTINGS.regionText) || {};
  /* owner 2026-10-11: "You're here - don't need to mention this need minimal and premium looks" + no note: the current store shows a tick
     only, the note is gone; both come back only if words are typed in the settings */
  var T_HEAD = TXT.head || 'Ship to', T_HERE = TXT.here || '', T_NOTE = TXT.note || '';
  var mark = function () { return '<span class="cy-ship__badge">' + CHECK + (T_HERE ? escHtml(T_HERE) : '') + '</span>'; };
  var ARROW = '<svg class="cy-ship__go" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 8h9.2M8.6 4l4 4-4 4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var cur = function (r) { return r.cur ? '<span class="cy-ship__cur">' + escHtml(r.cur) + '</span>' : ''; };

  function build() {
    var current = currentRegion();

    var wrap = document.createElement('div');
    wrap.className = 'cy-region hdt-site-nav_icon';
    wrap.setAttribute('data-cy-region', '');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cy-region__btn';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-haspopup', 'true');
    btn.setAttribute('aria-label', T_HEAD + ': ' + current.name + (current.cur ? ', ' + current.cur : '') + '. Change store');
    btn.innerHTML = current.flag + '<span class="cy-region__code">' + escHtml(current.code) + '</span>' + CARET;

    var panel = document.createElement('div');
    panel.className = 'cy-region__menu cy-ship';
    panel.hidden = true;
    var html = '<p class="cy-ship__head">' + escHtml(T_HEAD) + '</p>' +
      '<div class="cy-ship__here" aria-current="true" aria-disabled="true" aria-label="' + escHtml(current.name + (current.cur ? ', ' + current.cur : '') + ' (current store)') + '">' + current.flag +
        '<span class="cy-ship__txt"><span class="cy-ship__name">' + escHtml(current.name) + '</span><span class="cy-ship__host">' + escHtml(current.host) + '</span></span>' +
        cur(current) + mark() + '</div>' +
      '<ul class="cy-ship__list">';
    REGIONS.forEach(function (r) {
      if (r === current) return;
      html += '<li><a class="cy-ship__row" href="' + escHtml(r.url) + '">' + r.flag +
        '<span class="cy-ship__txt"><span class="cy-ship__name">' + escHtml(r.name) + '</span><span class="cy-ship__host">' + escHtml(r.host) + '</span></span>' +
        cur(r) + ARROW + '</a></li>';
    });
    html += '</ul>' + (T_NOTE ? '<p class="cy-ship__note">' + escHtml(T_NOTE) + '</p>' : '');
    panel.innerHTML = html;

    wrap.appendChild(btn);
    wrap.appendChild(panel);

    var rows = function () { return [].slice.call(panel.querySelectorAll('.cy-ship__row')); };
    var closeTimer = null, quiet = false;   /* quiet: the focus Escape hands back to the trigger must not reopen the panel */
    function close() { panel.hidden = true; btn.setAttribute('aria-expanded', 'false'); }
    function open() { panel.hidden = false; btn.setAttribute('aria-expanded', 'true'); }
    function cancelClose() { if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; } }
    function closeSoon() { cancelClose(); closeTimer = setTimeout(close, 180); }

    /* opens on hover where a real pointer exists, like the rest of the header; touch keeps the click */
    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      wrap.addEventListener('mouseenter', function () { cancelClose(); open(); });
      wrap.addEventListener('mouseleave', closeSoon);
      wrap.addEventListener('focusin', function () { if (quiet) return; cancelClose(); open(); });
      wrap.addEventListener('focusout', function (e) { if (!wrap.contains(e.relatedTarget)) closeSoon(); });
    }
    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); cancelClose(); panel.hidden ? open() : close(); });
    /* keyboard: down from the button enters the stores, up / down move between them, Escape closes */
    btn.addEventListener('keydown', function (e) { if (e.key === 'ArrowDown') { e.preventDefault(); open(); var r = rows(); if (r[0]) r[0].focus(); } });
    panel.addEventListener('keydown', function (e) {
      var r = rows(), i = r.indexOf(document.activeElement); if (i < 0) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); r[(i + 1) % r.length].focus(); }
      if (e.key === 'ArrowUp') { e.preventDefault(); i === 0 ? btn.focus() : r[i - 1].focus(); }
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) { cancelClose(); close(); quiet = true; btn.focus(); quiet = false; } });

    return wrap;
  }

  /* ---- the mobile copy: always open at the foot of the menu drawer (owner 2026-10-01), as a 2 x 2 grid of flag tiles: the
     current store a "You're here" tile that cannot be tapped, the others links; no repeated name, half the height of four rows ---- */
  function buildDrawer() {
    var current = currentRegion();
    var wrap = document.createElement('div');
    wrap.className = 'cy-region-mb cy-ship-mb';
    wrap.setAttribute('data-cy-region-mb', '');
    var html = '<p class="cy-ship__head">' + escHtml(T_HEAD) + '</p><ul class="cy-ship__tiles">';
    REGIONS.forEach(function (r) {
      var inner = '<span class="cy-ship__tile-top">' + r.flag + '<span class="cy-ship__name">' + escHtml(r.name) + '</span></span>' +
        '<span class="cy-ship__tile-foot">' + cur(r) + (r === current ? mark() : ARROW) + '</span>';
      html += r === current
        ? '<li><div class="cy-ship__tile is-here" aria-current="true" aria-disabled="true" aria-label="' + escHtml(r.name + (r.cur ? ', ' + r.cur : '') + ' (current store)') + '">' + inner + '</div></li>'
        : '<li><a class="cy-ship__tile" href="' + escHtml(r.url) + '">' + inner + '</a></li>';
    });
    html += '</ul>' + (T_NOTE ? '<p class="cy-ship__note">' + escHtml(T_NOTE) + '</p>' : '');
    wrap.innerHTML = html;
    return wrap;
  }

  function mountDrawer() {
    var hosts = document.querySelectorAll('.hdt-header-menu-mobile .hdt-mobile-other-content');
    if (!hosts.length) return false;
    var added = 0;
    hosts.forEach(function (host) {
      if (host.querySelector('[data-cy-region-mb]')) return;   // never mount twice
      host.appendChild(buildDrawer());
      added++;
    });
    return added > 0;
  }

  function mount() {
    var rows = document.querySelectorAll('.hdt-main-header .hdt-site-top_nav');
    if (!rows.length) return false;
    var added = 0;
    rows.forEach(function (row) {
      if (row.querySelector('[data-cy-region]')) return;   // never mount twice
      row.appendChild(build());                            // after the cart icon
      added++;
    });
    return added > 0;
  }

  function init() {
    var a = mount(), b = mountDrawer();
    if (a && b) return;
    /* the header can be re-rendered by the theme editor, and on a slow first
       paint the row may not exist yet - watch briefly, then give up */
    var tries = 0;
    var timer = setInterval(function () {
      var m = mount(), d = mountDrawer();
      if ((m && d) || ++tries > 20) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
